import { safeDefine } from "../../registration/safe-define.js";
import { TooltipElement } from "../../ui/tooltip/element.js";
//#region src/define/ui/tooltip.ts
safeDefine(TooltipElement);
//#endregion
